export const navigation = (() => {
  const mainNavButtons = document.querySelectorAll(".sideMenu-button");
  Array.from(mainNavButtons).forEach((toggleBtn) => addEL(toggleBtn));

  const links = document.querySelectorAll("#guide-menu .sideMenu-button");

  Array.from(links).forEach((link) => {
    link.addEventListener("click", function (e) {
      let hasChilds = e.currentTarget.classList.contains("sideMenu-button--has-children");
      let isLevel1 = e.currentTarget.classList.contains("level-1");
      if (hasChilds && isLevel1) {
        e.preventDefault();
      } else {
        const hasAccess = document
          .querySelector("#guide-menu")
          .getAttribute("data-restrict").length > 0;
        if (!hasAccess) {
          const dataId = e.currentTarget.getAttribute("data-id");
          const pathname = window.location.pathname + "/pagepreview?pageid=" + dataId;
          e.preventDefault();

          fetch(pathname)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            })
            .then((data) => {
              document.querySelector(
                ".subpagehero-content .content-heading"
              ).innerHTML = data.header;
              document.querySelector(
                ".subpagehero-content .content-preamble"
              ).innerHTML = data.preamble;
              document
                .querySelector(".subpagehero-content .content-preamble")
                .classList.add("gradient-cover-text");
              document.querySelector(".subpagehero-content .content-editorial").innerHTML = "";
              document.querySelector("#content-item").innerHTML = "";
              document.querySelector("#block-full").innerHTML = "";
              document.querySelector("#members-only").classList.remove("hidden");
              window.scrollTo({ top: 0, behavior: "smooth" });
            })
            .catch((error) => {
              console.error("Fetch error:", error); // Handle errors
            });
        }
      }
    });
  });

  function addEL(toggleBtn) {
    toggleBtn.addEventListener("click", function (e) {
      Array.from(mainNavButtons).forEach((b) => {
        if (e.target.classList.contains("sideMenu-button--action")) {
          e.preventDefault();
        }

        if (b === this) {
          const btn = this.querySelector(".sideMenu-button--action");
          if (btn == null) return;

          if (btn.getAttribute("aria-expanded") === "true") {
            this.classList.add("open");
          } else {
            this.classList.remove("open");
          }
          return;
        }

        let theId = b.getAttribute("aria-controls");
        b.setAttribute("aria-expanded", "false");

        let target = document.getElementById(theId);
        if (!target) return;

        target.setAttribute("aria-hidden", "true");
        target.classList.add("hidden");
      });

      // Update the parent's min-height based on the sideMenu's height plus an offset
      updateMainHeight();
    });
  }

  function updateMainHeight() {
    const sideMenu = document.querySelector(".sideMenu");
    const main = document.querySelector(".main > .container");
    if (!sideMenu || !main) return;

    // Only update the min-height if viewport is at least 1024px wide
    if (window.innerWidth >= 1024) {
      const height = sideMenu.offsetHeight + 350; // add 350px offset
      main.style.minHeight = height + "px";
    } else {
      main.style.minHeight = ""; // reset inline min-height for smaller viewports
    }
  }

  // Update min-height on initial load
  updateMainHeight();

  // Optional: Update min-height on window resize to handle dynamic viewport changes
  window.addEventListener("resize", updateMainHeight);

  // New: Add click event for .sideMenu-heading to toggle .sideMenu-list--expanded on its sibling .sideMenu-list
  // and toggle an active class on the heading itself.
  const headings = document.querySelectorAll('.sideMenu-heading');
  headings.forEach(heading => {
    heading.addEventListener('click', function () {
      // Find the sibling element with the class .sideMenu-list within the same parent.
      const siblingList = this.parentElement.querySelector('.sideMenu-list');
      if (siblingList) {
        siblingList.classList.toggle('sideMenu-list--expanded');
        // Toggle an active class on the heading based on the sibling list's state.
        if (siblingList.classList.contains('sideMenu-list--expanded')) {
          this.classList.add('sideMenu-heading--active');
        } else {
          this.classList.remove('sideMenu-heading--active');
        }
      }
    });
  });
})();
